// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"914e54c9","769":"f0eeffb0"}[chunkId] + ".chunk.css";
};